const LazyLoad = require('vanilla-lazyload');

module.exports = {
  init() {
    window.theEmailSubscribeLazyLoad = new LazyLoad({
      elements_selector: '.email-subscribe-landing__image.lazy',
      class_loading: 'email-subscribe-landing__image--loading',
      class_loaded: 'email-subscribe-landing__image--loaded',
    });
  },
};
